(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("LogicCloudWebDialler", [], factory);
	else if(typeof exports === 'object')
		exports["LogicCloudWebDialler"] = factory();
	else
		root["LogicCloudWebDialler"] = factory();
})(self, () => {
return 